import { optimizeAndConvertToWebp } from '../../services/imageOptimizerService';
import { getAdminUploadUrl } from '../../services/SubscriptionService';

/**
 * Upload a subscription asset (logo, QR, etc.) using the same WebP + S3 presigned
 * flow as product images, but via the super-admin subscription upload endpoint.
 */
export async function uploadSubscriptionAsset(file, prefix = 'subscription-logos') {
    if (!file) throw new Error('No file selected');

    const optimizedPreview = await optimizeAndConvertToWebp(file);
    const fileType = 'image/webp';
    const safePrefix = (prefix || 'subscription-logos').replace(/[^a-zA-Z0-9_-]/g, '');
    const fileName = `${safePrefix}-${Date.now()}.webp`;

    const byteCharacters = atob(optimizedPreview.split(',')[1]);
    const byteArrays = [];
    for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
    }
    const blob = new Blob([new Uint8Array(byteArrays)], { type: fileType });

    const response = await getAdminUploadUrl(fileName, fileType, safePrefix);
    if (!response?.success || !response?.data?.uploadUrl) {
        throw new Error(response?.error || response?.message || 'Could not prepare upload');
    }

    const { uploadUrl, publicUrl } = response.data;
    const put = await fetch(uploadUrl, {
        method: 'PUT',
        body: blob,
        headers: { 'Content-Type': fileType },
    });

    if (!put.ok) {
        throw new Error(`Upload failed (${put.status}). Please try again.`);
    }

    return publicUrl;
}
